import React,{useEffect,useState} from 'react';
import { BrowserRouter as Router,Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './pages/Home.js';
import PublicHousingWL from './pages/PublicHousingWL.js';
import Signup from './pages/Signup.js';
import Login from './pages/Login.js';
import Blog from './pages/Blog.js';
import BlogDetail from './pages/BlogDetail.js';
import Section8WL from './pages/Section8WL.js';
import EmergencyRentalAssistance from './pages/EmergencyRentalAssistance.js';
import CommunityActionCenter from './pages/CommunityActionCenter.js';
import CommunityActionCenterStateAndCounty from './pages/CommunityActionCenterStateAndCounty.js';
import CommunityActionCenterDetail from './pages/CommunityActionCenterDetail.js';


const App=()=>{

const [data, setData] = useState([]);

  return (
    <Router>
      <Routes>
        <Route exact path='/' element={< Home />}></Route>
        <Route exact path='/public-housing-waiting-lists' element={<PublicHousingWL />}></Route>
        <Route exact path='/signup' element={<Signup />}></Route>
        <Route exact path='/login' element={<Login />}></Route>
        <Route exact path='/section-8-waiting-lists' element={<Section8WL />}></Route>
        <Route exact path='/emergency-rental-assistance' element={<EmergencyRentalAssistance />}></Route>
        <Route exact path='/community-action-center' element={<CommunityActionCenter />}></Route>
        
        <Route exact path='/blog' element={<Blog />}></Route>
        <Route exact path='/blog/:id' element={<BlogDetail />}></Route>

        <Route exact path='/public-housing-waiting-lists/:state' element={<Home />}></Route>
        <Route exact path='/section-8-waiting-lists/:state' element={<Section8WL />}></Route>
        <Route exact path='/emergency-rental-assistance/:state' element={<EmergencyRentalAssistance />}></Route>
        <Route exact path='/community-action-center/:state' element={<CommunityActionCenter />}></Route>
        <Route exact path='/community-action-center/:state/:county' element={<CommunityActionCenterStateAndCounty />}></Route>
        <Route exact path='/community-action-center-detail/:item' element={<CommunityActionCenterDetail />}></Route>

      </Routes>
    </Router>
  );
}

export default App;
